import { createQueryString } from '@toss/utils';

import { type GoogleClassroomCreateAssignmentDialogProps } from '@/shared/googleClassroom/hooks';

import { GOOGLE_CLASSROOM_LANDING_PAGE_TYPE_PARAM_KEY } from './constants';
import { googleClassroomApiClient } from './createGoogleClassroomApiClient';
import {
  type AddOnAttachment,
  type GoogleClassroomPageContext,
  LandingPageType,
} from './types';

export class TeacherClient {
  private static _axiosInstance = googleClassroomApiClient;

  static async createAssignment({
    quizSet,
    options,
  }: {
    quizSet: GoogleClassroomCreateAssignmentDialogProps['quizSet'];
    options: {
      oauthToken: string;
      context: GoogleClassroomPageContext;
    };
  }): Promise<AddOnAttachment> {
    const { context, oauthToken } = options;
    if (context.pageType !== LandingPageType.AttachmentSetup) {
      throw new Error('Method not allowed in this context.');
    }

    const { courseId, itemId, addOnToken } = context.params;
    const url = `/courses/${courseId}/courseWork/${itemId}/addOnAttachments`;

    const response = await this._axiosInstance.post<AddOnAttachment>(
      url,
      {
        title: quizSet.title,
        teacherViewUri: {
          uri: `${
            location.origin
          }/google-classroom/play-bridge${createQueryString({
            entryMapHashId: quizSet.entryMapHashId,
            [GOOGLE_CLASSROOM_LANDING_PAGE_TYPE_PARAM_KEY]:
              LandingPageType.TeacherView,
          })}`,
        },
        studentViewUri: {
          uri: `${
            location.origin
          }/google-classroom/play-bridge${createQueryString({
            entryMapHashId: quizSet.entryMapHashId,
            [GOOGLE_CLASSROOM_LANDING_PAGE_TYPE_PARAM_KEY]:
              LandingPageType.StudentView,
          })}`,
        },
        studentWorkReviewUri: {
          uri: `${
            location.origin
          }/google-classroom/student-work-review${createQueryString({
            [GOOGLE_CLASSROOM_LANDING_PAGE_TYPE_PARAM_KEY]:
              LandingPageType.StudentWorkReview,
          })}`,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${oauthToken}`,
        },
        params: {
          addOnToken,
        },
      },
    );
    return response.data;
  }
}
